module.exports = __webpack_public_path__ + "img/page.ba030df2.png";